import { loadStripe } from '@stripe/stripe-js';
import { config } from '../config/env';

/**
 * Stripe.js instance - singleton
 * Initialized once and reused throughout the application
 */
let stripePromise = null;

/**
 * Get or initialize Stripe instance
 * @returns {Promise<Stripe|null>} Stripe instance or null if key is missing
 */
export const getStripe = () => {
  if (!stripePromise) {
    const key = config.stripePublishableKey;

    // Validate key exists
    if (!key) {
      console.error('[Stripe] Publishable key not configured');
      return null;
    }

    // Validate key format
    if (!key.startsWith('pk_')) {
      console.error('[Stripe] Invalid publishable key format. Key must start with "pk_"');
      return null;
    }

    // Log mode (test vs live) in development
    if (config.isDevelopment) {
      const mode = key.startsWith('pk_live_') ? 'LIVE' : 'TEST';
      console.log(`[Stripe] Initializing in ${mode} mode`);

      if (mode === 'LIVE' && config.isDevelopment) {
        console.warn('[Stripe] WARNING: Using LIVE key in development mode!');
      }
    }

    stripePromise = loadStripe(key);
  }

  return stripePromise;
};

/**
 * Reset Stripe promise - useful for testing
 * @private
 */
export const resetStripePromise = () => {
  stripePromise = null;
};

export default getStripe;
